module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/show-movimientos/show-movimientos.component.css
// module id = ./src/app/show-movimientos/show-movimientos.component.css
// module chunks = main